import Login from 'utils/login';
import { ROLES } from 'constants/role';
import School from 'utils/school';
import Student from 'utils/student';
export const getUserAttribute = async () => {
  let ret = {};
  if (Login.isLogin()) {
    ret.user_unique_id = await getUserId();
    if (Login.lastRole === ROLES.STUDENT) {
      ret = { ...ret, ...(await getStudentInfoData()) };
    }
  }
  return ret;
};
export const getUserId = async () => {
  let ret = '';
  if (Login.lastRole === ROLES.STUDENT) {
    let statusData = await Login.getStatusData();
    ret = statusData.user_id;
  } else if (Login.lastRole === ROLES.SCHOOL) {
    let shcoolInfo = await School.getInfo();
    let id = shcoolInfo.id;
    ret = `s_${id}`;
  }
  return ret;
};
export const getStudentInfoData = async () => {
  let ret = {};
  const statusData = await Login.getStatusData();
  const infoData = await Student.getInfo();
  const applyData = await Student.getApplyData();
  const personalData = applyData || {};
  ret.user_phone = infoData?.phone;
  ret.user_email = infoData?.email;
  ret.gender = getGender(personalData.gender);
  ret.user_country = infoData?.school_country_id || '';
  ret.user_state = infoData?.school_state_id || '';
  ret.city = infoData?.school_city_id || '';
  ret.user_school = infoData?.school_id || infoData?.school_name || '';
  ret.user_batch = getBatch(statusData.batch_str);
  ret.user_signup_status = getApplyStatusStr(statusData);
  ret.user_activate_time = statusData?.activate_status_v5?.activate_at || '';
  ret.user_improve_personal_time = statusData?.activate_status_v5?.info_completed_at || '';
  ret.user_improve_basic_time = statusData?.apply_v5?.step1_submitted_at || '';
  ret.user_pay_time = statusData?.activate_status_v5?.apply_paid_at || '';
  ret.user_finish_apply_time = statusData?.apply_v5?.step2_submitted_at || '';
  return ret;
};
export const getApplyStatusStr = status => {
  const is_applied = status?.apply_v5?.step1_submitted;
  const is_apply_paid = status?.activate_status_v5?.apply_paid || status?.is_tuition_paid;
  const is_step2_applied = status?.apply_v5?.step2_submitted;
  const is_completed = status?.activate_status_v5?.info_completed;
  let ret = '';
  if (is_step2_applied) {
    ret = '申请';
  } else if (is_apply_paid) {
    ret = '支付';
  } else if (is_applied) {
    ret = '报名';
  } else if (is_completed) {
    ret = '激活';
  }
  return ret;
};
export const getBatch = batch => {
  return /eb/i.test(batch || '') ? 'eb' : 'rd';
};
export const getGender = gender => {
  return (
    {
      1: '男',
      2: '女'
    }[gender] || '未知'
  );
};
